var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-empty"},[_c('img',{staticClass:"empty-image",attrs:{"src":"/img/empty.png","alt":"暂未搜索到结果"}}),_c('div',{staticClass:"empty-tip"},[_vm._v("没有找到相关"+_vm._s(this.$attrs.tipsMode||'课程')+"，请先看看别的吧～")])])
}
var staticRenderFns = []

export { render, staticRenderFns }